import { CSSProperties } from 'react';
import { withIcon } from './withIcon';

const ChevronRightSVG = ({ style }: { style?: CSSProperties }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path d="M13.3341 10.0002C13.3348 10.1098 13.3138 10.2186 13.2723 10.3201C13.2308 10.4216 13.1697 10.514 13.0925 10.5918L8.09247 15.5918C7.93555 15.7488 7.72272 15.8369 7.50081 15.8369C7.27889 15.8369 7.06606 15.7488 6.90914 15.5918C6.75222 15.4349 6.66406 15.2221 6.66406 15.0002C6.66406 14.7783 6.75222 14.5654 6.90914 14.4085L11.3258 10.0002L6.91747 5.59184C6.78095 5.43242 6.70961 5.22736 6.71771 5.01763C6.72581 4.8079 6.81276 4.60895 6.96117 4.46054C7.10958 4.31212 7.30853 4.22518 7.51826 4.21708C7.72799 4.20898 7.93305 4.28032 8.09247 4.41684L13.0925 9.41684C13.2464 9.57206 13.3332 9.78155 13.3341 10.0002Z" />
  </svg>
);

export const ChevronRight = withIcon(ChevronRightSVG);
